var common={
	getQueryString:function(name){
		var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
	    var r = window.location.search.substr(1).match(reg);
	    if(r!=null)return  unescape(r[2]); return null;
	},
	login:function(){
		if(this.getQueryString("tycredidential")!=null&&this.getQueryString("tycredidential")!=""){
			CommonJSHelper.tyInvalid()
		}else{
			CommonJSHelper.login();
		}
	},
	closePage:function() {
			if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.closePage) {
				window.webkit.messageHandlers.closePage.postMessage(1)
			} else if (typeof CommonJSHelper !== 'undefined') {
				CommonJSHelper.closePage()
			}
	},
	showUrlInNewpage:function(url) {
		if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.showUrlInNewpage) {
			window.webkit.messageHandlers.showUrlInNewpage.postMessage(url)
		} else if (typeof CommonJSHelper !== 'undefined') {
			CommonJSHelper.showUrlInNewpage(url)
		}
	}
}

module.exports=common;


//////////////////
// WEBPACK FOOTER
// ./pages/yubashuo/js/common.js
// module id = 2
// module chunks = 0 1 2